<template>
  <Modal 
    :id="'cmp-add-licenceAccounts'"
    @cancelled="onCancel"
  >
    
    <template slot="header"> </template>

    <template slot="body">
      <div class="contact-search">
        <InputField
          :id="'contact_search'"
          :value="searchString"
          :placeholder="'Search'"
          :config="{
                    borderStyle: 'around'
                }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>

      <table class="dt-table2 contact-table">
        <thead class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
                        'margin-right': hRowMarginRight
                    }"
          >
            <th class="dt-table2--column">Name</th>
          
          </tr>
        </thead>
        <tbody class="dt-table2--body">
        <tr
          class="dt-table2--row"
          v-for="item in licenceAccountList"
          :key="item.licence_account_id"
          @click="e => onRowClicked(item)"
        >
            <td class="dt-table2--column">{{item['licence_account_name']}}</td>
         
          </tr>
        </tbody>
      </table>
    </template>

    <template slot="options">
        <button class="dt-button s6" @click="onCancel">Cancel</button>
        <!-- <button v-if="licenceAccountSearchResult.length==0" class="dt-button v1 s6" @click="onAddGenre">Add Genre</button> -->
        
    
 
      
    </template>

  </Modal>
</template>

<script>
// import { BookingStoreNamespace as storeNS, BookingStoreNamespace } from '../../../store';
// import * as ActionTypes from '../../../store/types';

// import {mapGetters, mapActions} from 'vuex';


import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";

import InputField from "@/plugins/text-field/input-field";

import { waitForAnimation, subscribeSubject } from "@/utility";

import Modal from '../../../../dt-plugins/modal/modal';
import { createModalMixin, closeModal2Route, openModal2Route } from "../../../../dt-plugins/modal/modal.mixin";
import { licenceService } from '../../services/licence.service';
import { licenceAccountsService } from "../../services/licence-accounts.service";




export default {
  props: {


  },
  components: {
    InputField,

    Modal
  },
  mixins: [
 
  ],
  // watch: {
  //   searchString: {
  //     immediate: true,
  //     handler: function(to, from) {
  //       console.log(`searchString Change to ${to} from ${from}`);
  //     }
  //   }
  // },
  data: function() {
    return {
      licenceAccounts: [],
      searchString: "",
      licenceAccountSubject$: new Subject(),
      licenceAccountSearchResult:[],
     
      searchSize: "single",

      
    
     

    
    
    };
  },
  mounted:async function() {
 
    
   const resData= await licenceService.selectLcncAccForm();

    console.log("RESDATA",resData); 
    this.licenceAccounts=resData.data.licence_accounts;

   subscribeSubject(this, this.licenceAccountSubject$, searchString => {
        
      
        licenceAccountsService.licenceAccountList(0,1000,searchString).then( res =>{
          console.log("RESRESRES",res)
          this.licenceAccountSearchResult = res.data.licence_accounts
        });
       
  })

  },
  computed: {

    
    hRowMarginRight: function() {
      if (this.licenceAccounts.length > 380 / 28) {
        return "28px";
      }
    },
  
    external_id: function() {
      return this.$route.query.external_id;
    },

    licenceAccountList:function(){
      if(this.searchString.length>0){
        return this.licenceAccountSearchResult
      }
      else{
        return this.licenceAccounts
      }
    }
  },
  methods: {
    addChecklist: function(e) {
      // this.$emit('ADD_NEW', this.checklist_title);
      this.checklist_title = "";
      // this.$emit('CANCEL', false);
    },

    onSearchInputKeyup: function(e) {
      this.searchString = e.target.value;
      console.log(this.searchString, e.target.value);
      this.licenceAccountSubject$.next(this.searchString);
    },
    searchContact: function() {
      ContactService.searchContacts({
        searchString: this.searchString
      }).then(contacts => {
        this.contacts = contacts.map(createContact);
      });
    },
    onRowClicked: async function(item) {
       this.$router.push({
        ...this.$route,
        query: {
          modal: "create_licence_form",
          licence_account_id:item.licence_account_id
        },
      });  
      //this.onCancel();    
    },
    onCancel: function() {
  
      this.$emit("cancelled", true);
    },
    // onAddPersonClicked: function(e) {
    //   // this.$router.push({
    //   //   ...this.$route,
    //   //   query: {
    //   //     ...this.$route.query,
    //   //     modal2: 'add_person'
    //   //   }
    //   // });
    //   openModal2Route(this, 'add_person');

    //   // this.addPersonModalContainer = true;
    //   // waitForAnimation(() => {
    //   //   this.addPersonModal = true;
    //   // });
    // },
    // onAddPersonCancelled: function() {
    //   // this.$router.push({
    //   //   query: {
    //   //     ...this.$route.query,
    //   //     modal2: undefined
    //   //   }
    //   // });
    //   closeModal2Route(this);
    //   // this.addPersonModal = false;

    //   // waitForAnimation(() => {
    //   //   this.addPersonModalContainer = false;
    //   // });
    // },
    // onAddCompanyClicked: function() {
    //   openModal2Route(this, 'add_company');
    //   // this.addCompanyModalContainer = true;
    //   // waitForAnimation(() => {
    //   //   this.addCompanyModal = true;
    //   // });
    // },
    // onAddCompanyCancelled: function() {
    //   closeModal2Route(this);
    //   // this.addCompanyModal = false;

    //   // waitForAnimation(() => {
    //   //   this.addCompanyModalContainer = false;
    //   // });
    // },

    onAddGenre: function() {
      const payload={ genre_name:this.searchString } 
       this.$emit("create",payload)
    }
  }
};


</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 290px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      //background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {

  button{
      &:first-child {
          margin-right: 10px;
      }
      &:last-child {
          margin-left:0px 10px;
      }
  }
}
</style>